
export const name = "laboratory-lib-cdn";
export const version = "1.5310";
